import { json, relation, text } from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";
import { Relation } from "@nozbe/watermelondb";
import Department from "./Department";
import { noopSanitizeJSON } from "../utils";
import { Markup } from "@towersystems/roam-common/lib/generated-types";

export default class Category extends BaseModel {
  static table = "categories";
  @relation("departments", "department_id") department: Relation<Department>;

  @text("name") name: string;
  @text("description") description: string | null;
  @json("markup", noopSanitizeJSON) markup?: Markup[];
  @text("preferred_tax_group_id") preferredTaxGroupId: string | null;
}
